"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const JsonViewer_1 = require("../../JsonViewer");
exports.ListItem = (props) => {
    const { components, handleItemOpen, resource } = props;
    // Full overwrite
    if (components && components.ListItemContainer) {
        return react_1.default.createElement(components.ListItemContainer, Object.assign({}, props));
    }
    // Overwrite of the content only
    const contentNode = components && components.ListItem
        ? react_1.default.createElement(components.ListItem, Object.assign({}, props))
        : react_1.default.createElement(JsonViewer_1.JsonViewer, { json: { resource } });
    const onSelect = () => handleItemOpen(resource.id);
    return (react_1.default.createElement(rsuite_1.Panel, { bordered: true, style: { margin: 10 }, onClick: onSelect }, contentNode));
};
//# sourceMappingURL=ListItem.js.map